import type { Invoice } from "@/types";
import { formatCurrencyWithSymbol } from "@/utils/currency";

interface FinancialSummaryProps {
  invoice: Invoice & {
    subtotal?: number | null;
    tax_amount?: number | null;
    total_amount?: number | null;
    payment_method?: string | null;
  };
}

export default function FinancialSummary({ invoice }: FinancialSummaryProps) {
  const hasFinancialData = [
    invoice.subtotal,
    invoice.tax_amount,
    invoice.total_amount,
  ].some((value) => value !== null && value !== undefined);

  if (!hasFinancialData) {
    return null;
  }

  return (
    <div className="space-y-4">
      <h2 className="text-base font-medium">Resumen Financiero</h2>
      <div className="grid gap-4 md:grid-cols-3">
        {invoice.subtotal !== null && invoice.subtotal !== undefined && (
          <div className="space-y-2">
            <div className="text-sm font-medium text-muted-foreground">
              Subtotal
            </div>
            <p className="text-lg font-medium">
              {formatCurrencyWithSymbol(invoice.subtotal, invoice.currency)}
            </p>
          </div>
        )}
        {invoice.tax_amount !== null && invoice.tax_amount !== undefined && (
          <div className="space-y-2">
            <div className="text-sm font-medium text-muted-foreground">
              IVA
            </div>
            <p className="text-lg font-medium">
              {formatCurrencyWithSymbol(invoice.tax_amount, invoice.currency)}
            </p>
          </div>
        )}
        {invoice.total_amount !== null && invoice.total_amount !== undefined && (
          <div className="space-y-2">
            <div className="text-sm font-medium text-muted-foreground">
              Total
            </div>
            <p className="text-2xl font-bold text-primary">
              {formatCurrencyWithSymbol(invoice.total_amount, invoice.currency)}
            </p>
          </div>
        )}
      </div>
      {invoice.payment_method && (
        <div className="grid gap-4 md:grid-cols-3">
          <div className="space-y-2">
            <div className="text-sm font-medium text-muted-foreground">
              Condición de Pago
            </div>
            <p className="text-base font-medium">{invoice.payment_method}</p>
          </div>
        </div>
      )}
    </div>
  );
}
